import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/oops.svg'


const _withScopeId = n => (_pushScopeId("data-v-31d25bf0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "not-found" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "image-wrapper" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "oops logo"
  })
], -1))
const _hoisted_3 = { class: "content-wrapper" }
const _hoisted_4 = { id: "text" }
const _hoisted_5 = {
  id: "main-title",
  class: "big_headline"
}
const _hoisted_6 = { class: "small_headline" }
const _hoisted_7 = { class: "body_text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("NOTFOUND.MAIN_TITLE")), 1),
        _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("NOTFOUND.SECONDARY_TITLE")), 1),
        _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("NOTFOUND.TEXT")), 1),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.moveToHomepage()))
        }, _toDisplayString(_ctx.$t("NOTFOUND.BUTTON")), 1)
      ])
    ])
  ]))
}